import React from 'react';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import Text from '../components/Text';
import {
  ANDROID_PLAY_STORE_URL,
  IOS_APP_STORE_URL,
  getSmartphoneOs,
} from '../utils/deviceInfo';

const MobileAppDownload = () => {
  const { t, i18n } = useTranslation();
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';
  const os = getSmartphoneOs();
  const lang = i18n.language?.startsWith('en') ? 'en' : 'fr';
  const showIos = os === 'ios' || os === 'other';
  const showAndroid = os === 'android' || os === 'other';
  const mutedText = isDarkMode ? 'rgba(255,255,255,0.52)' : 'rgba(0,0,0,0.52)';
  const appStoreBadge =
    lang === 'en'
      ? '/assets/v3/img/Download_on_the_App_Store_Badge_EN.svg'
      : '/assets/v3/img/Download_on_the_App_Store_Badge_FR.svg';
  const playStoreBadge =
    lang === 'en'
      ? 'https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png'
      : 'https://play.google.com/intl/fr_ca/badges/static/images/badges/fr_badge_web_generic.png';

  return (
    <Box
      sx={{
        minHeight: '100dvh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: 3,
        py: 6,
        boxSizing: 'border-box',
        background: isDarkMode
          ? 'radial-gradient(circle at top, rgba(255,255,255,0.04), transparent 42%), #09090B'
          : 'radial-gradient(circle at top, rgba(255,255,255,0.9), transparent 42%), #F4F4F7',
      }}
    >
      <Box sx={{ width: '100%', maxWidth: 360, textAlign: 'center' }}>
        <Box
          component="img"
          src="/apple-touch-icon.png"
          alt="Node BOS"
          sx={{
            width: 72,
            height: 72,
            borderRadius: '18px',
            mb: 3,
            objectFit: 'cover',
            border: `1px solid ${
              isDarkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.08)'
            }`,
          }}
        />

        <Text
          value={t('mobileAppDownloadTitle')}
          fontSize={28}
          fontWeight={700}
          sx={{ letterSpacing: '-0.03em', lineHeight: 1.15, mb: 1.5 }}
        />
        <Text
          value={t('mobileAppDownloadSubtitle')}
          fontSize={15}
          fontWeight={400}
          sx={{ color: mutedText, lineHeight: 1.5, mb: 4 }}
        />

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 1.5,
            py: 1,
            px: 2,
            borderRadius: '16px',
            background: isDarkMode ? 'rgba(255,255,255,0.96)' : 'transparent',
          }}
        >
          {showIos && (
            <Box
              component="a"
              href={IOS_APP_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={t('downloadOnAppStore')}
              sx={{ display: 'block', lineHeight: 0 }}
            >
              <Box
                component="img"
                src={appStoreBadge}
                alt={t('downloadOnAppStore')}
                sx={{ height: 44, width: 'auto' }}
              />
            </Box>
          )}
          {showAndroid && (
            <Box
              component="a"
              href={ANDROID_PLAY_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={t('downloadOnGooglePlay')}
              sx={{ display: 'block', lineHeight: 0 }}
            >
              <Box
                component="img"
                src={playStoreBadge}
                alt={t('downloadOnGooglePlay')}
                sx={{ height: 60, width: 'auto' }}
              />
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default MobileAppDownload;
